import { Card, CardHeader, CardPreview, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    card: {
        minWidth: "300px",
        minHeight: "150px",
        marginLeft: "1vw",
        marginRight: "1vw",
    },
    header: {
        paddingTop: "15px",
        fontSize: "150%",
        textAlign: "center",

    },
    title: {

    },
    value: {
        paddingTop: "15px",
        display: "block",
        fontSize: "400%",
        textAlign: "center",
    },
});

type NumberBoardProp = {
    title: string;
    value: number;
}

const NumberBoard = ({ title = "", value = 0 }: NumberBoardProp) => {
    const styles = useStyles();
    return (
        <Card className={styles.card}>
            <CardHeader
                className={styles.header}
                header={title}
            >
            </CardHeader>
            <CardPreview
                className={styles.value}
            >
                {value}
            </CardPreview>
        </Card>

    );
}

export default NumberBoard;